import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const RouteContext = createContext("/");

export function navigate(to) {
  if (to === window.location.pathname + window.location.hash) return;
  window.history.pushState({}, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function RouterProvider({ children }) {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return <RouteContext.Provider value={path}>{children}</RouteContext.Provider>;
}

export function usePath() {
  return useContext(RouteContext);
}

/* Internal link: keeps navigation client-side, but still a real <a> for
   middle-click, new tab, and crawlers. */
export function Link({ to, children, ...rest }) {
  const onClick = useCallback(
    (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      navigate(to);
      const hash = to.split("#")[1];
      // Wait a frame so the destination page has rendered before scrolling.
      requestAnimationFrame(() => {
        const el = hash && document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        else window.scrollTo(0, 0);
      });
    },
    [to]
  );

  return (
    <a href={to} onClick={onClick} {...rest}>
      {children}
    </a>
  );
}
